const SYSTEM_CONSTANTS = {
    HOST:'https://hoaxuyenchi.org.vn',
    hoatdong: 'hoadongnoibat',
    IDENTITY: {
        LOGIN: 'api/auth/local',
        FORGOT: 'users',
        PROFILE: 'api/user/me',
        ROLE: 'api/users-permissions/roles',
    },
    Config: {
        GET: 'api/configs',
    },
    BestPost: {
        GET: 'api/best-posts',
    },
    Post: {
        GET: 'api/posts',
    },
    Child: {
        GET: 'api/children',
    },
    PRODUCTION: {
        GET: 'api/productions',
    },
    TAG: {
        GET: 'api/tags',
    },
    CATEGORY: {
        GET: 'api/categories',
    },
    HomeData: {
        GET: 'api/data-homes',
    },
    Video: {
        GET: 'api/videos'
    }
};

export default SYSTEM_CONSTANTS;
